// Timeline/scene thumbnails: the fabric renderer produces full-size PNGs
// (1-3 MB each for 1280x720 frames). Downscale them to a small JPEG so the
// timeline can hold dozens of scenes without bloating memory.
export const downscaleDataURL = (dataUrl: string, maxWidth = 160): Promise<string> =>
  new Promise((resolve) => {
    if (!dataUrl || typeof dataUrl !== "string" || !dataUrl.startsWith("data:image")) {
      resolve(dataUrl)
      return
    }
    const img = new Image()
    img.onload = () => {
      try {
        const scale = Math.min(1, maxWidth / img.width)
        const width = Math.max(1, Math.round(img.width * scale))
        const height = Math.max(1, Math.round(img.height * scale))
        const canvas = document.createElement("canvas")
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext("2d")
        if (!ctx) {
          resolve(dataUrl)
          return
        }
        ctx.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL("image/jpeg", 0.82))
      } catch {
        resolve(dataUrl)
      }
    }
    img.onerror = () => resolve(dataUrl)
    img.src = dataUrl
  })

export const renderScenePreview = async (editor: any, scene: any, maxWidth = 160): Promise<string> => {
  if (!editor || !scene) return ""
  // A stuck asset load (image that never fires load/error) must not hang the
  // whole thumbnail queue; bail out and let the next scene render.
  const timeout = new Promise<string>((resolve) => setTimeout(() => resolve(""), 15000))
  const rendered = (async () => {
    const preview = (await editor.renderer.render(scene)) as string
    return downscaleDataURL(preview, maxWidth)
  })()
  return Promise.race([rendered, timeout])
}
